import { isFullname, hasTitleName } from "@mobi/utils/validators/name"
import wordsLengthLessThen from "@mobi/utils/validators/wordLengthLessThen"
import mergeDeep from "@mobi/utils/object/mergeDeep"
import { useController } from "react-hook-form"

import { Input } from "@mobi/ds"
import { handleChange, handleBlur } from '../../handlerMethods'

const DEFAULT_MESSAGES = {
  required: "campo obrigatório",
  fullName: "Nome inválido",
  titleName: "Não pode conter 'dr', 'dra', 'sr', 'sra', ou 'eng'",
  max20CharPerWord: "Limite de 20 caracteres por palavra",
  max150length: "Limite máximo de 150 caracteres",
}


const DEFAULT_RULES = {
  validate: {
    fullName: (name) => isFullname(name),
    titleName: (name) => hasTitleName(name),
    max20CharPerWord: (name) => wordsLengthLessThen(20, name),
    max150length: (name) => !!!(name.length >= 150),
  },
}

const Name = ({
  name = "name",
  label = "nome completo",
  type = "text",
  required = true,
  autoComplete = "on",
  validators: { rules: propRules = {}, messages: propMessages = {} } = {},
  onChange = () => null,
  onBlur = () => null,
  control,
  ...props
}) => {
  const rules = mergeDeep(DEFAULT_RULES, propRules, { required })
  const errorMessages = mergeDeep(DEFAULT_MESSAGES, propMessages)
  const {
    field,
    fieldState: { error, invalid, isTouched, isDirty },
  } = useController({ name, control, rules })

  const isInvalid = isTouched && invalid && isDirty

  return (
    <Input.Default
      {...props}
      value={field.value}
      name={field.name}
      onChange={(event) => handleChange(event, field, onChange)}
      onBlur={(event) => handleBlur(event, field, onBlur)}
      label={label}
      type={type}
      autoComplete={autoComplete}
      isValid={!isInvalid}
      errorMessage={errorMessages[error?.type]}
      aria-required={required}
    />
  )
}

export default Name
